type AnchorLink = { href?: string; onPress?: () => void };

export function anchorHref({ href }: AnchorLink): string | undefined {
	return href;
}
